const istate = {
  loading: false,
  linearLoading: false,
  isDarkMode: false,
};

const commonReducer = (state = istate, action) => {
  switch (action.type) {
    case "LOADING": {
      state = {
        ...state,
        loading: action.payload,
      };
      return state;
    }
    case "LINEAR_LOADING": {
      state = {
        ...state,
        linearLoading: action.payload,
      };
      return state;
    }
    case "SET_THEME": {
      state = {
        ...state,
        isDarkMode: !state.isDarkMode,
      };
      return state;
    }
    default:
      return state;
  }
};

export default commonReducer;
